import React from 'react';

import styles from '../styles/sectionNav.module.css';

class SectionNav extends React.Component {
  constructor(props) {
    super(props);
    this.theme = this.props.theme || 'lite';

    this.containerStyle = `${styles.sectionNavContainer} ${
      this.theme === 'dark' && styles.sectionNavContainerDark
    }`;

    this.linkStyle = `${styles.navLink} ${
      this.theme === 'dark' && styles.navLinkDark
    }`;
  }

  render() {
    return (
      <section
        id="section-nav"
        dataCy="section-nav"
        className={`${this.containerStyle} ${this.props.className || ''}`}
      >
        {this.props.data.fields.map(data => {
          const { description, selector } = data;
          return (
            <a className={this.linkStyle} href={`#${selector}`}>
              <span className={styles.border}>{description}</span>
            </a>
          );
        })}
      </section>
    );
  }
}

export default SectionNav;
